module.exports = __webpack_public_path__ + "resources/27963f10586f4adb3ee60ddd844bafee.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/background.jpg
// module id = 209
// module chunks = 0